// Fields:
export const NAME = "name";
export const FIRST_NAME = "firstName";
export const GENDER = "gender";
export const HEIGHT = "height";
export const WEIGHT = "weight";
export const DESIRED_WEIGHT = "desiredWeight";
export const WEIGHT_LOSS = "weightLoss";
export const WEIGHT_RESULT = "weightResult";
export const GDPR = "gdpr";
export const PASSWORD = "password";
export const ACCOUNT_CREATION = "accountCreation";
export const PHONE_NUMBER = "phoneNumber";
export const MAILING_ADDRESS = "mailingAddress";
export const ADDRESS_LINE_1 = "addressLine1";
export const ADDRESS_LINE_2 = "addressLine2";
export const CITY = "city";
export const ZIPCODE = "zipcode";
export const COUNTRY = "country";
export const COUPON_CODE = "couponCode";
// Eli Longer fields:
export const STATE = "state";
export const PANCREATITIS_CAUSE = "pancreatitisCause";
export const PANCREATITIS_CAUSE_UNKNOWN = "pancreatitisCauseUnknown"; // "I do not know" checkbox
export const PANCREATITIS_YEAR = "pancreatitisYear";
export const GALLBLADDER_YEAR = "gallbladderYear";
export const GALLBLADDER_EXPERIENCE = "gallbladderExperience";
export const ALLERGEN_MEDICATION = "allergenMedication";
export const BLOOD_PRESSURE = "bloodPressure";
export const BLOOD_PRESSURE_UNKNOWN = "bloodPressureUnknown"; // "I do not know" checkbox
export const HEART_RATE = "heartRate";
export const DOB = "dob";
export const EMAIL = "email";

// Other Eli Longer constants:
export const MEDICAL = "medical";
export const BLOOD_PRESSURE_SYS = "systolic";
export const BLOOD_PRESSURE_DIA = "diastolic";

// Eli Longer variable name for saving email.
export const LOCAL_STORAGE_EMAIL = "ww_assessment_email";

// Other constants:
export const LAST_NAME = "lastName";
export const MALE = "M";
export const FEMALE = "F";
export const NONBINARY = "NB";
export const OTHER = "O";
export const MEASUREMENT_SYSTEM = "measurementSystem";
export const WEIGHT_UNIT = "weightUnit";
export const HEIGHT_UNIT = "heightUnit";
export const MINIMUM_BMI = 19;
export const MINIMUM_BMI_RECOMMENDED = 19.1;
export const SINGLE_CHOICE = "singleChoice";
export const US = "US";
export const LOGGED_IN_AS = "loggedInAs";
export const STATE_NEXT_STEP_PAGE = "stateNextStepPage";
export const OPTIN = "optin";
